module.exports = __webpack_public_path__ + "img/back_active2.a2202ebd.png";